import React, { CSSProperties, FC, useEffect, useState } from 'react'

import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { isEmpty } from 'lodash'

import { useAppSelector } from '../../store/hooks'
import { LocalJournalingProgress } from '../../store/types'

import { JournalingCellProps } from './types'

export const JournalingCell: FC<JournalingCellProps> = ({ id, value, selectedRow }) => {
  const { spacing, palette } = useTheme()
  const [currentLocalJournalingCell, setCurrentLocalJournalingCell] = useState<
    LocalJournalingProgress | undefined
  >(undefined)
  const { localJournalingProgressData } = useAppSelector((state) => state.localJournalingProgress)

  useEffect(() => {
    if ((!selectedRow || !id) && !isEmpty(localJournalingProgressData)) return

    const localCell = localJournalingProgressData.find(
      (item) => item.tradingLogId === selectedRow || item.tradingLogId === id?.toString(),
    )

    setCurrentLocalJournalingCell(localCell)
  }, [localJournalingProgressData])

  const container: CSSProperties = {
    position: 'relative',
    height: spacing(1),
    width: spacing(10),
    marginLeft: 'auto',
    borderRadius: spacing(0.5),
    backgroundColor: palette.grey[300],
  }

  const progressLine: CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: `calc(${Number(currentLocalJournalingCell?.journalingProgress || value)} * 100%)`,
    height: '100%',
    borderRadius: spacing(0.5),
    backgroundColor: palette.blue[500],
  }

  return (
    <Box sx={container}>
      <Box sx={progressLine}></Box>
    </Box>
  )
}
